module.exports = __webpack_public_path__ + "assets/3061755360149d8da118473fe2c463d5.mp3";